import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";

import Video from "../assets/bg-video.mp4";
import ButtonImage from "../assets/enter-btn-1.png";
import sf from "../assets/sf-logo.png";
import Audio from "../assets/bg-audio.mp3";

const FirstPage = () => {
  const navigate = useNavigate();

  const [logoOpacity, setLogoOpacity] = useState(0);
  const [buttonOpacity, setButtonOpacity] = useState(0);

  // Audio
  const audioRef = useRef(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  /* ---------------- LOGO FADE IN ---------------- */
  useEffect(() => {
    const logoTimer = setTimeout(() => {
      let current = 0;
      const interval = setInterval(() => {
        if (current < 1) {
          current += 0.1;
          setLogoOpacity(Number(current.toFixed(2)));
        } else {
          clearInterval(interval);
        }
      }, 600);
    }, 5900);

    return () => clearTimeout(logoTimer);
  }, []);

  /* ---------------- BUTTON FADE IN ---------------- */
  useEffect(() => {
    const buttonTimer = setTimeout(() => {
      let current = 0;
      const interval = setInterval(() => {
        if (current < 1) {
          current += 0.1;
          setButtonOpacity(Number(current.toFixed(2)));
        } else {
          clearInterval(interval);
        }
      }, 800);
    }, 17000);

    return () => clearTimeout(buttonTimer);
  }, []);

  /* ---------------- AUTO-PLAY WHEN COMING BACK ---------------- */
  useEffect(() => {
    const allowed = sessionStorage.getItem("audioAllowed");

    if (allowed === "true" && audioRef.current) {
      audioRef.current
        .play()
        .then(() => setIsAudioPlaying(true))
        .catch(() => {});
    }
  }, []);

  /* ---------------- ENTER BUTTON ---------------- */
  const handleEnter = () => {
    sessionStorage.setItem("audioAllowed", "true");
    navigate("/home");
  };

  /* ---------------- AUDIO TOGGLE ---------------- */
  const toggleAudio = async () => {
    if (!audioRef.current) return;

    if (isAudioPlaying) {
      audioRef.current.pause();
      setIsAudioPlaying(false);
    } else {
      try {
        await audioRef.current.play();
        setIsAudioPlaying(true);
      } catch {
        console.warn("Autoplay blocked");
      }
    }
  };

  return (
    <div style={{ position: "relative", height: "100vh", overflow: "hidden" }}>
      {/* AUDIO */}
      <audio ref={audioRef} autoPlay loop preload="auto" muted={false}>
        <source src={Audio} type="audio/mp3" />
      </audio>

      {/* VIDEO */}
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "fill",
          zIndex: -1,
        }}
      >
        <source src={Video} type="video/mp4" />
      </video>

      {/* ENTER BUTTON */}
      <button
  className="landing-enter"
  onClick={handleEnter}
  style={{
    position: "absolute",
    width: "12vw",
    bottom: "35vh",
    right: "18vw",
    background: "transparent",
    border: "none",
    padding: 0,
    cursor: "pointer",
    opacity: buttonOpacity,
    transition: "opacity 0.3s",
  }}
>
  <img
    src={ButtonImage}
    alt="Enter"
    style={{
      display: "block",
      width: "12vw",
      height: "auto",
    }}
    onMouseEnter={(e) =>
      (e.currentTarget.style.transform = "scale(1.1)")
    }
    onMouseLeave={(e) =>
      (e.currentTarget.style.transform = "scale(1)")
    }
  />
</button>

      {/* LOGOS */}
      <div
        className="landing-logos"
        style={{
          position: "absolute",
          top: "3vh",
          right: "2vw",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          opacity: logoOpacity,
        }}
      >

        <a
          href="https://samskritifoundation.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={sf} alt="SF Logo" style={{ height: "13vh" }} />
        </a>
      </div>

      {/* SPEAKER BUTTON */}
      <button
  onClick={toggleAudio}
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: isAudioPlaying ? "black" : "white",
    borderRadius: "50%",
    padding: "12px",
    zIndex: 999,
    cursor: "pointer",
    border: "none",
    transition: "background 0.3s ease", // smooth effect
  }}
>
  <FontAwesomeIcon
    icon={faVolumeUp}
    size="lg"
    color={isAudioPlaying ? "white" : "black"}
  />
</button>

{/* Mobile Portrait Styles */}
      <style>
        {`
          
@media (max-width: 600px) and (orientation: portrait) {
  .landing-logos {
    top: 2.5vh !important;
    right: 3vw !important;
    gap: 46vw !important;
  }

  .landing-logos img {
    height: 8vh !important;
    width: auto !important;
  }

  /* Enter button - mobile portrait */
  .landing-enter {
    position: absolute;
    width: 100vw;
    bottom: 36vh;
    left: 73%;
    right: auto;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .landing-enter img {
    width: 38vw !important;
    max-width: 220px;
    min-width: 140px;
    height: auto;
  }
}
        `}
      </style>

    </div>
  );
};

export default FirstPage;
